var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#FFC2DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.273 24.545-.57 1.14a3.091 3.091 0 0 1-1.382 1.381l-1.14.57 1.14.57c.598.298 1.083.783 1.382 1.382l.57 1.139.569-1.14c.3-.598.784-1.083 1.383-1.382l1.138-.57-1.139-.569a3.09 3.09 0 0 1-1.382-1.382l-.57-1.14zM32.273 16.817l.569-1.14a3.09 3.09 0 0 1 1.383-1.382l1.138-.57-1.139-.569a3.091 3.091 0 0 1-1.382-1.382l-.57-1.14-.57 1.14a3.091 3.091 0 0 1-1.381 1.382l-1.14.57 1.14.57a3.09 3.09 0 0 1 1.382 1.381l.57 1.14zM15.272 18.363l1.085-2.17a3.09 3.09 0 0 1 1.382-1.382l2.17-1.085-2.17-1.085a3.09 3.09 0 0 1-1.382-1.382l-1.085-2.17-1.085 2.17a3.091 3.091 0 0 1-1.382 1.383l-2.17 1.084 2.17 1.085c.598.299 1.083.784 1.382 1.382l1.085 2.17zM27.823 18.175a3.091 3.091 0 0 0-4.371 0L11.618 30.008a3.091 3.091 0 0 0 4.371 4.371l11.834-11.833a3.09 3.09 0 0 0 0-4.371zm-1.093 3.278-1.093 1.093-2.185-2.186 1.092-1.092a1.545 1.545 0 1 1 2.186 2.185z",
    fill: "#EF0554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMagic);
export default __webpack_public_path__ + "static/media/homeMagic.33e6e375541e43cecaf61d7732d6e7c2.svg";
export { ForwardRef as ReactComponent };